import React from "react";
import Button from "@material-ui/core/Button";
import { PasswordInput, regex, required } from "react-admin";
import { Paper, Grid } from "@material-ui/core";


const validatePassword = regex(
  /^(?=.*\d)(?=.*[a-z])[\w~@#$%^&*+=`|{}:;!.?"()[\]-]{6,20}$/,
  "Password must contain one Small, one Capital letter and should be atleast minimum 6 charachters long"
);
const validateConfirmPassword = (values) => (password) =>
  values.Password === password
    ? undefined
    : { message: "Password does not match" };
export const ResetPasswordForm = ({
  handleSubmit,
  reset,
  submitting,
  pristine,
  values,
  props,
  ...rest
}) => {

  return (
    <form onSubmit={handleSubmit} noValidate>
      <Paper style={{ padding: 5, boxShadow: "none" }}>
        <Grid container alignItems="flex-start" spacing={2}>
          <Grid item xs={12}>
            <PasswordInput
              source="Password"
              variant="standard"
              validate={[required(), validatePassword]}
              fullWidth
              label="Enter Password"
            />
          </Grid>

          <Grid item xs={12}>
            <PasswordInput
              source="ConfirmPassword"
              variant="standard"
              fullWidth
              validate={[required(), validateConfirmPassword(values)]}
              label="Confirm Password"
            />
          </Grid>

          <Grid item xs={12} style={{ marginTop: 16, width: "100%" }}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={submitting}
              style={{ width: "100%" }}
            >
              Change Password
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </form>
  );
};
